'use client';

import { useState } from 'react';
import { Menu, X } from 'lucide-react';
import AppLogo from '@/components/ui/AppLogo';
import Link from 'next/link';

const navLinks = [
  { label: 'Services', href: '#services' },
  { label: 'Pricing', href: '#pricing' },
  { label: 'Contact', href: '#contact' },
  { label: 'Case Studies', href: '/case-studies' },
  { label: 'Site Scan', href: '/diagnostic' },
];

export default function PublicNav() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [adminClicks, setAdminClicks] = useState(0);

  const handleLogoClick = () => {
    const next = adminClicks + 1;
    setAdminClicks(next);
    if (next >= 5) {
      window.location.href = '/login-screen';
    }
  };

  return (
    <nav className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-slate-100">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <button
            type="button"
            onClick={handleLogoClick}
            className="focus:outline-none"
            aria-label="BloodHound"
            title={adminClicks > 0 ? `${5 - adminClicks} more...` : undefined}
          >
            <AppLogo size={32} />
          </button>
          <span className="font-bold text-lg text-slate-900 tracking-tight">BloodHound</span>
        </div>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks?.map((link) => (
            <a
              key={`nav-${link?.label}`}
              href={link?.href}
              className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors duration-150"
            >
              {link?.label}
            </a>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#contact"
            className="text-sm font-semibold text-white bg-slate-900 px-5 py-2.5 rounded-lg hover:bg-slate-700 transition-all duration-150 active:scale-95"
          >
            Get in Touch
          </a>
          {/* Hidden admin access — bottom-right corner pixel */}
          <Link
            href="/login-screen"
            className="w-1 h-1 opacity-0 hover:opacity-100 bg-green-500 rounded-full transition-opacity duration-300 cursor-pointer"
            aria-label=""
            tabIndex={-1}
          />
        </div>

        {/* Mobile hamburger */}
        <button
          type="button"
          className="md:hidden p-2 text-slate-600 hover:text-slate-900 transition-colors"
          onClick={() => setMobileOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {mobileOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>
      {/* Mobile drawer */}
      {mobileOpen && (
        <div className="md:hidden border-t border-slate-100 bg-white px-6 py-4 space-y-3 fade-in">
          {navLinks?.map((link) => (
            <a
              key={`mobile-nav-${link?.label}`}
              href={link?.href}
              onClick={() => setMobileOpen(false)}
              className="block text-sm font-medium text-slate-700 py-2"
            >
              {link?.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setMobileOpen(false)}
            className="block text-sm font-semibold text-center text-white bg-slate-900 px-5 py-2.5 rounded-lg mt-2"
          >
            Get in Touch
          </a>
        </div>
      )}
    </nav>
  );
}